/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesAccountType } from './WebApiModelsEnumerationTypesAccountType';
import {
    WebApiModelsEnumerationTypesAccountTypeFromJSON,
    WebApiModelsEnumerationTypesAccountTypeFromJSONTyped,
    WebApiModelsEnumerationTypesAccountTypeToJSON,
} from './WebApiModelsEnumerationTypesAccountType';
import type { WebApiModelsEnumerationTypesCompanyTypeConfiguration } from './WebApiModelsEnumerationTypesCompanyTypeConfiguration';
import {
    WebApiModelsEnumerationTypesCompanyTypeConfigurationFromJSON,
    WebApiModelsEnumerationTypesCompanyTypeConfigurationFromJSONTyped,
    WebApiModelsEnumerationTypesCompanyTypeConfigurationToJSON,
} from './WebApiModelsEnumerationTypesCompanyTypeConfiguration';
import type { WebApiModelsEnumerationTypesFamilyMemberConfiguration } from './WebApiModelsEnumerationTypesFamilyMemberConfiguration';
import {
    WebApiModelsEnumerationTypesFamilyMemberConfigurationFromJSON,
    WebApiModelsEnumerationTypesFamilyMemberConfigurationFromJSONTyped,
    WebApiModelsEnumerationTypesFamilyMemberConfigurationToJSON,
} from './WebApiModelsEnumerationTypesFamilyMemberConfiguration';
import type { WebApiModelsEnumerationTypesFamilyMemberDisplayMode } from './WebApiModelsEnumerationTypesFamilyMemberDisplayMode';
import {
    WebApiModelsEnumerationTypesFamilyMemberDisplayModeFromJSON,
    WebApiModelsEnumerationTypesFamilyMemberDisplayModeFromJSONTyped,
    WebApiModelsEnumerationTypesFamilyMemberDisplayModeToJSON,
} from './WebApiModelsEnumerationTypesFamilyMemberDisplayMode';
import type { WebApiModelsEnumerationTypesPaymenConfiguration } from './WebApiModelsEnumerationTypesPaymenConfiguration';
import {
    WebApiModelsEnumerationTypesPaymenConfigurationFromJSON,
    WebApiModelsEnumerationTypesPaymenConfigurationFromJSONTyped,
    WebApiModelsEnumerationTypesPaymenConfigurationToJSON,
} from './WebApiModelsEnumerationTypesPaymenConfiguration';
import type { WebApiModelsEnumerationTypesRole } from './WebApiModelsEnumerationTypesRole';
import {
    WebApiModelsEnumerationTypesRoleFromJSON,
    WebApiModelsEnumerationTypesRoleFromJSONTyped,
    WebApiModelsEnumerationTypesRoleToJSON,
} from './WebApiModelsEnumerationTypesRole';
import type { WebApiModelsEnumerationTypesSubscriptionLevel } from './WebApiModelsEnumerationTypesSubscriptionLevel';
import {
    WebApiModelsEnumerationTypesSubscriptionLevelFromJSON,
    WebApiModelsEnumerationTypesSubscriptionLevelFromJSONTyped,
    WebApiModelsEnumerationTypesSubscriptionLevelToJSON,
} from './WebApiModelsEnumerationTypesSubscriptionLevel';
import type { WebApiModelsEnumerationTypesSubscriptionStatus } from './WebApiModelsEnumerationTypesSubscriptionStatus';
import {
    WebApiModelsEnumerationTypesSubscriptionStatusFromJSON,
    WebApiModelsEnumerationTypesSubscriptionStatusFromJSONTyped,
    WebApiModelsEnumerationTypesSubscriptionStatusToJSON,
} from './WebApiModelsEnumerationTypesSubscriptionStatus';
import type { WebApiServicesDataTransferObjectsUserServiceCompanySelectionDto } from './WebApiServicesDataTransferObjectsUserServiceCompanySelectionDto';
import {
    WebApiServicesDataTransferObjectsUserServiceCompanySelectionDtoFromJSON,
    WebApiServicesDataTransferObjectsUserServiceCompanySelectionDtoFromJSONTyped,
    WebApiServicesDataTransferObjectsUserServiceCompanySelectionDtoToJSON,
} from './WebApiServicesDataTransferObjectsUserServiceCompanySelectionDto';

/**
 * Data transfer object for the M:WebApi.Services.Interfaces.IUserService.AuthenticateAsync(WebApi.Services.DataTransferObjects.UserService.AuthenticateReqDto) response.
 * @export
 * @interface WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
 */
export interface WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto {
    /**
     * Gets or sets the identifier.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    id?: string;
    /**
     * Gets or sets the Name.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    firstName?: string | null;
    /**
     * Gets or sets the Name.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesSubscriptionLevel}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    subscriptionLevel?: WebApiModelsEnumerationTypesSubscriptionLevel;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    hasPaidSubscription?: boolean;
    /**
     * Gets or sets the Name.
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    subscriptionIsActive?: boolean;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesSubscriptionStatus}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    subscriptionStatus?: WebApiModelsEnumerationTypesSubscriptionStatus;
    /**
     * The date the paid subscription runs until.
     * @type {Date}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    nextSubscriptionRenewalDate?: Date | null;
    /**
     * The date after which adding members is blocked (renewal date + grace period).
     * @type {Date}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    subscriptionLockDate?: Date | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesAccountType}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    accountType?: WebApiModelsEnumerationTypesAccountType;
    /**
     * Gets or sets the email.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    email?: string | null;
    /**
     * Gets or sets the token.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    token?: string | null;
    /**
     * Gets or sets the token.
     * @type {Date}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    tokenExpires?: Date;
    /**
     * Gets or sets the token.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    companyId?: number;
    /**
     * Gets or sets the token.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    companyLanguage?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesRole}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    role?: WebApiModelsEnumerationTypesRole;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesCompanyTypeConfiguration}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    companyType?: WebApiModelsEnumerationTypesCompanyTypeConfiguration;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesPaymenConfiguration}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    paymentConfiguration?: WebApiModelsEnumerationTypesPaymenConfiguration;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesFamilyMemberConfiguration}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    familyMemberConfiguration?: WebApiModelsEnumerationTypesFamilyMemberConfiguration;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesFamilyMemberDisplayMode}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    familyMemberDisplayMode?: WebApiModelsEnumerationTypesFamilyMemberDisplayMode;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    hasOnlyReadRights?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    maxEmails?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    maxAdministrators?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    maxReadAdministrators?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    maxMembers?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    smsCredits?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    requiresCompanySelection?: boolean;
    /**
     * 
     * @type {Array<WebApiServicesDataTransferObjectsUserServiceCompanySelectionDto>}
     * @memberof WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto
     */
    availableCompanies?: Array<WebApiServicesDataTransferObjectsUserServiceCompanySelectionDto> | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsUserServiceAuthenticateResDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsUserServiceAuthenticateResDtoFromJSON(json: any): WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto {
    return WebApiServicesDataTransferObjectsUserServiceAuthenticateResDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsUserServiceAuthenticateResDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'subscriptionLevel': !exists(json, 'subscriptionLevel') ? undefined : WebApiModelsEnumerationTypesSubscriptionLevelFromJSON(json['subscriptionLevel']),
        'hasPaidSubscription': !exists(json, 'hasPaidSubscription') ? undefined : json['hasPaidSubscription'],
        'subscriptionIsActive': !exists(json, 'subscriptionIsActive') ? undefined : json['subscriptionIsActive'],
        'subscriptionStatus': !exists(json, 'subscriptionStatus') ? undefined : WebApiModelsEnumerationTypesSubscriptionStatusFromJSON(json['subscriptionStatus']),
        'nextSubscriptionRenewalDate': !exists(json, 'nextSubscriptionRenewalDate') ? undefined : (json['nextSubscriptionRenewalDate'] === null ? null : new Date(json['nextSubscriptionRenewalDate'])),
        'subscriptionLockDate': !exists(json, 'subscriptionLockDate') ? undefined : (json['subscriptionLockDate'] === null ? null : new Date(json['subscriptionLockDate'])),
        'accountType': !exists(json, 'accountType') ? undefined : WebApiModelsEnumerationTypesAccountTypeFromJSON(json['accountType']),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'token': !exists(json, 'token') ? undefined : json['token'],
        'tokenExpires': !exists(json, 'tokenExpires') ? undefined : (new Date(json['tokenExpires'])),
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'companyLanguage': !exists(json, 'companyLanguage') ? undefined : json['companyLanguage'],
        'role': !exists(json, 'role') ? undefined : WebApiModelsEnumerationTypesRoleFromJSON(json['role']),
        'companyType': !exists(json, 'companyType') ? undefined : WebApiModelsEnumerationTypesCompanyTypeConfigurationFromJSON(json['companyType']),
        'paymentConfiguration': !exists(json, 'paymentConfiguration') ? undefined : WebApiModelsEnumerationTypesPaymenConfigurationFromJSON(json['paymentConfiguration']),
        'familyMemberConfiguration': !exists(json, 'familyMemberConfiguration') ? undefined : WebApiModelsEnumerationTypesFamilyMemberConfigurationFromJSON(json['familyMemberConfiguration']),
        'familyMemberDisplayMode': !exists(json, 'familyMemberDisplayMode') ? undefined : WebApiModelsEnumerationTypesFamilyMemberDisplayModeFromJSON(json['familyMemberDisplayMode']),
        'hasOnlyReadRights': !exists(json, 'hasOnlyReadRights') ? undefined : json['hasOnlyReadRights'],
        'maxEmails': !exists(json, 'maxEmails') ? undefined : json['maxEmails'],
        'maxAdministrators': !exists(json, 'maxAdministrators') ? undefined : json['maxAdministrators'],
        'maxReadAdministrators': !exists(json, 'maxReadAdministrators') ? undefined : json['maxReadAdministrators'],
        'maxMembers': !exists(json, 'maxMembers') ? undefined : json['maxMembers'],
        'smsCredits': !exists(json, 'smsCredits') ? undefined : json['smsCredits'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'requiresCompanySelection': !exists(json, 'requiresCompanySelection') ? undefined : json['requiresCompanySelection'],
        'availableCompanies': !exists(json, 'availableCompanies') ? undefined : (json['availableCompanies'] === null ? null : (json['availableCompanies'] as Array<any>).map(WebApiServicesDataTransferObjectsUserServiceCompanySelectionDtoFromJSON)),
    };
}

export function WebApiServicesDataTransferObjectsUserServiceAuthenticateResDtoToJSON(value?: WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'subscriptionLevel': WebApiModelsEnumerationTypesSubscriptionLevelToJSON(value.subscriptionLevel),
        'hasPaidSubscription': value.hasPaidSubscription,
        'subscriptionIsActive': value.subscriptionIsActive,
        'subscriptionStatus': WebApiModelsEnumerationTypesSubscriptionStatusToJSON(value.subscriptionStatus),
        'nextSubscriptionRenewalDate': value.nextSubscriptionRenewalDate === undefined ? undefined : (value.nextSubscriptionRenewalDate === null ? null : value.nextSubscriptionRenewalDate.toISOString()),
        'subscriptionLockDate': value.subscriptionLockDate === undefined ? undefined : (value.subscriptionLockDate === null ? null : value.subscriptionLockDate.toISOString()),
        'accountType': WebApiModelsEnumerationTypesAccountTypeToJSON(value.accountType),
        'email': value.email,
        'token': value.token,
        'tokenExpires': value.tokenExpires === undefined ? undefined : (value.tokenExpires.toISOString()),
        'companyId': value.companyId,
        'companyLanguage': value.companyLanguage,
        'role': WebApiModelsEnumerationTypesRoleToJSON(value.role),
        'companyType': WebApiModelsEnumerationTypesCompanyTypeConfigurationToJSON(value.companyType),
        'paymentConfiguration': WebApiModelsEnumerationTypesPaymenConfigurationToJSON(value.paymentConfiguration),
        'familyMemberConfiguration': WebApiModelsEnumerationTypesFamilyMemberConfigurationToJSON(value.familyMemberConfiguration),
        'familyMemberDisplayMode': WebApiModelsEnumerationTypesFamilyMemberDisplayModeToJSON(value.familyMemberDisplayMode),
        'hasOnlyReadRights': value.hasOnlyReadRights,
        'maxEmails': value.maxEmails,
        'maxAdministrators': value.maxAdministrators,
        'maxReadAdministrators': value.maxReadAdministrators,
        'maxMembers': value.maxMembers,
        'smsCredits': value.smsCredits,
        'companyName': value.companyName,
        'requiresCompanySelection': value.requiresCompanySelection,
        'availableCompanies': value.availableCompanies === undefined ? undefined : (value.availableCompanies === null ? null : (value.availableCompanies as Array<any>).map(WebApiServicesDataTransferObjectsUserServiceCompanySelectionDtoToJSON)),
    };
}

